import { parseUtcDateTime } from "../../helpers/utc-date";

// Submission includes the server-local offset; completion is explicitly stored in UTC.
// SQL drops the UTC kind, so restore it before formatting both in the browser's timezone.
export const formatImportDate = (value, utc = false) => {
  if (!value) return "—";
  const date = utc ? parseUtcDateTime(value) : new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
};
